import apiClient from './client';

const PLAYERS_COUNT_CACHE_TTL_MS = 60 * 1000;

let playersCountCacheValue = null;
let playersCountCacheExpiresAt = 0;
let playersCountInFlightPromise = null;

export const getPlayersCount = async () => {
  const now = Date.now();
  if (playersCountCacheValue !== null && now < playersCountCacheExpiresAt) {
    return playersCountCacheValue;
  }

  if (playersCountInFlightPromise) {
    return playersCountInFlightPromise;
  }

  try {
    playersCountInFlightPromise = apiClient
      .get(`/stats/players`)
      .then((response) => {
        const players = response?.data?.players ?? null;
        if (players !== null) {
          playersCountCacheValue = players;
          playersCountCacheExpiresAt = Date.now() + PLAYERS_COUNT_CACHE_TTL_MS;
        }
        return players;
      });

    return await playersCountInFlightPromise;
  } catch (error) {
    console.error('[Stats] Failed to fetch players count:', error);
    return null;
  } finally {
    playersCountInFlightPromise = null;
  }
};

export const getAccountsCount = async () => {
  try {
    const response = await apiClient.get(`/stats/accounts`);
    return response.data.accounts;
  } catch (error) {
    console.error('[Stats] Failed to fetch accounts count:', error);
    return null;
  }
};
